import { ModulBasis } from './ModulBasis';
import { ModulBpm } from './ModulBpm';
import { ModulPat } from './ModulPat';
import * as React from 'react';

export interface ModuleProps {
    data: any;
    isPdf?: boolean;
    jahr: number;
    standortTid?: number;
    jsxB3Co2?: JSX.Element;
    getPageNum?: (key: string, page: number, level: number) => void;
}

export class Module extends React.Component<ModuleProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    render(): JSX.Element {
        return <>
            <ModulBasis {...this.props} />
            <ModulPat {...this.props} />
            <ModulBpm {...this.props} />
        </>;
    }
}
